import { UI, HStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { useNavigation } from '@react-navigation/native';
import { Button } from 'native-base';
import React from 'react';

import { VisitLegacyPage } from '../../../../components/VisitLegacyPage';
import { SignedInNavigationScreenNavigationProp } from '../../../../routes/types';

interface SubscriptionHeaderProps {
  isMobile: boolean;
  onReturn: () => void;
}

export const SubscriptionHeader: React.FC<SubscriptionHeaderProps> = ({ isMobile, onReturn }) => {
  const { navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();

  const onSubscriptionLegacyPress = () =>
    navigate({
      name: 'AngularFrame_VoluntaryEvents',
      params: { state: 'app.eventosVoluntarios' },
    });

  if (isMobile) {
    return (
      <HStack alignItems="center" justifyContent={'space-between'}>
        <Button
          p={0}
          testID="return-button"
          size="lg"
          variant="textLink"
          leftIcon={<UI.Icon name="ArrowLeft" size="xxs" color={Color['neutral.black']} />}
          justifyContent="start"
          onPress={onReturn}
          _text={{
            color: Color['neutral.black'],
            textTransform: 'initial',
            pl: Spacing['inline.nano'],
            fontSize: Typography['fontsize.lg'],
          }}>
          Eventos de Subscrição
        </Button>
        <VisitLegacyPage onPress={onSubscriptionLegacyPress} />
      </HStack>
    );
  }

  return (
    <HStack alignItems="center" justifyContent="space-between" w="full">
      <HStack alignItems="center" space="inline.xxxs">
        <UI.IconButton
          icon="ArrowLeft"
          testId="return-button"
          iconColor={Color['brand.tertiary.principal']}
          iconSize="xs"
          shadow={3}
          variant="link"
          onPress={onReturn}
        />
        <UI.Heading testId="qa" size="h2">
          Eventos de Subscrição
        </UI.Heading>
      </HStack>
      <VisitLegacyPage onPress={onSubscriptionLegacyPress} />
    </HStack>
  );
};
